import { Layout, Menu, Typography, Avatar, Space, Dropdown } from "antd";
import {
  DashboardOutlined,
  TransactionOutlined,
  PieChartOutlined,
  LineChartOutlined,
  WalletOutlined,
  TeamOutlined,
  UserOutlined,
  LogoutOutlined,
  CalendarOutlined,
  ProjectOutlined,
  ShopOutlined,
} from "@ant-design/icons";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useGetIdentity, useLogout } from "@refinedev/core";

const { Sider, Header, Content } = Layout;
const { Title, Text } = Typography;

interface Identity {
  id: number;
  email: string;
  full_name: string;
  role: string;
}

export const AppLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data: identity } = useGetIdentity<Identity>();
  const { mutate: logout } = useLogout();

  // Меню: только маршруты, у которых есть страница в этой итерации MVP.
  // Остальные добавим в Phase 3b.
  const items = [
    { key: "/dashboard", icon: <DashboardOutlined />, label: "Дашборд" },
    { key: "/transactions", icon: <TransactionOutlined />, label: "Транзакции" },
    { key: "/budget", icon: <PieChartOutlined />, label: "Бюджет", disabled: true },
    { key: "/forecast", icon: <LineChartOutlined />, label: "Прогноз", disabled: true },
    { key: "/funds", icon: <WalletOutlined />, label: "Фонды", disabled: true },
    { key: "/dividends", icon: <TeamOutlined />, label: "Дивиденды", disabled: true },
    { key: "/deals", icon: <ShopOutlined />, label: "Сделки", disabled: true },
    { key: "/projects", icon: <ProjectOutlined />, label: "Проекты", disabled: true },
    { key: "/calendar", icon: <CalendarOutlined />, label: "Календарь", disabled: true },
  ];

  const userMenuItems = [
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "Выйти",
      onClick: () => logout(),
    },
  ];

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        width={220}
        style={{
          background: "#001529",
          position: "fixed",
          left: 0,
          top: 0,
          bottom: 0,
          overflowY: "auto",
          zIndex: 10,
        }}
      >
        <div
          style={{
            padding: "16px 20px",
            color: "#fff",
            borderBottom: "1px solid rgba(255,255,255,0.08)",
          }}
        >
          <Title level={5} style={{ color: "#fff", margin: 0 }}>
            BNLegal Finance
          </Title>
          <Text style={{ color: "rgba(255,255,255,0.55)", fontSize: 12 }}>v0.1 MVP</Text>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={items.map((it) => ({
            key: it.key,
            icon: it.icon,
            label: it.label,
            disabled: it.disabled,
            onClick: () => !it.disabled && navigate(it.key),
          }))}
        />
      </Sider>
      <Layout style={{ marginLeft: 220 }}>
        <Header
          style={{
            background: "#fff",
            padding: "0 24px",
            borderBottom: "1px solid #f0f0f0",
            height: 48,
            lineHeight: "48px",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          {identity && (
            <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
              <Space style={{ cursor: "pointer" }}>
                <Avatar size="small" icon={<UserOutlined />} />
                <Text>{identity.full_name || identity.email}</Text>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  ({identity.role})
                </Text>
              </Space>
            </Dropdown>
          )}
        </Header>
        <Content
          style={{
            padding: "20px 24px",
            background: "#f5f5f5",
            overflow: "auto",
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};
